import React, { memo } from 'react';
import BlockMarkdown from '../structured/BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockItems } from '../structured/structuredBlockUtils';
import styles from './consultantReport.module.css';

function FindingsList({ blocks, renderContext }) {
    const items = blocks.flatMap(block => {
        const blockItems = extractBlockItems(block);
        return blockItems.map((item, index) => ({
            ...item,
            id: item.id || `${block.id}-finding-${index}`,
            block,
        }));
    });

    if (!items.length) return null;

    return (
        <div className={styles.findingList}>
            {items.map(item => {
                const title = item.title || item.label;
                const content = item.content || item.markdown || item.description || item.text;
                const confidence = item.confidence ?? item.confidence_label;
                if (!title && !content) return null;
                return (
                    <article key={item.id} className={styles.findingCard}>
                        {title ? <div className={styles.findingTitle}>{title}</div> : null}
                        {confidence != null && confidence !== '' ? (
                            <span className={styles.findingConfidence}>{String(confidence)} confidence</span>
                        ) : null}
                        {content ? <BlockMarkdown content={content} {...renderContext} /> : null}
                        <ClaimSupportFooter
                            block={{ ...item.block, citations: item.citations || item.supporting_refs || item.block?.citations }}
                            renderContext={renderContext}
                        />
                    </article>
                );
            })}
        </div>
    );
}

export default memo(FindingsList);
